module.exports = __webpack_public_path__ + "img/Pasarelas16.395e56c1.jpg";